<template>
  <div class="layout-wrapper">
    <sidebar></sidebar>

    <main class="main-content-area">
      <section id="chatInterface" class="screen-section">
        <input type="hidden" id="bot" value="general">
        <div id="chatHistory" class="chat-history">
          <!-- #todo: get user data from store -->
        </div>
      </section>
    </main>
  </div>
</template>

<script setup>
import { onMounted, defineProps } from 'vue';
import Sidebar from "@/components/Sidebar.vue";
import {useAuthStore} from "@/stores/auth.js";
import { useConversationStore } from "@/stores/conversation.js";
import { marked } from "marked";

const authStore = useAuthStore();
const user = authStore.getUser();

const props = defineProps({
  uuid: String
});

onMounted(() => {
  if (props.uuid) {
    loadConversation(props.uuid);
  }
});

watch(() => props.uuid, (newUuid) => {
  if (newUuid) {
    loadConversation(newUuid);
  }
});

const loadConversation = (uuid) => {
  const chatHistory = document.getElementById('chatHistory');
  chatHistory.innerHTML = ''; // Clear any existing messages

  let messagesLength = 0;

  useConversationStore().getCurrentConversationMessages(uuid, true).then((messages) => {
    messages.forEach(message => {
      const messageDiv = document.createElement('div');
      messageDiv.className = `message ${message.actor === 'user' ? 'user-msg' : 'bot-msg'}`;

      const html = marked(message.content);
      messageDiv.innerHTML = html;
      chatHistory.appendChild(messageDiv);
      messagesLength++;
    });

    if (messagesLength > 0) {
      chatHistory.scrollTop = chatHistory.scrollHeight;
    } else {
      const welcomeMessage = document.createElement('div');
      welcomeMessage.className = 'message bot-msg';
      welcomeMessage.textContent = `Welcome! How can I assist you today?`;
      chatHistory.appendChild(welcomeMessage);
    }
  }).catch(error => {
    console.error('Error loading conversation messages:', error);
  });
};
</script>
